import { LitElement, html } from "lit";

import sharedStyles from "../../styles/shared.js";
import tableStyles from "../../styles/tables.js";

export default class QuestionView extends LitElement {
	render() {
		return html`
    ${sharedStyles}
    ${tableStyles}
      <header class="horizontal-menu-header">
        <router-link to="/questions">
          <a>List</a>
        </router-link>
        <router-link to="/questions/new">
          <a>New</a>
        </router-link>
      </header>
      <slot></slot>
    `;
	}
}

customElements.define("question-view", QuestionView);
